/**
 * Received Documents Feature Types
 */

export type AcceptanceStatus = "pending" | "accepted" | "rejected";

export type DteTypeCode = 33 | 34 | 52 | 56 | 61;

export interface ReceivedDocumentListItem {
  id: string;
  documentType: string;
  documentTypeCode: string;
  folio: number;
  issueDate: string;
  issuerTaxId: string;
  issuerName: string | null;
  netAmount: string | null;
  taxAmount: string | null;
  totalAmount: string;
  acceptanceStatus: AcceptanceStatus;
  receivedAt: string;
  daysUntilDeadline: number | null;
}

export interface ReceivedDocumentDetails extends ReceivedDocumentListItem {
  currency: string;
  receivedVia: string;
  acceptedAt: string | null;
  rejectedAt: string | null;
  rejectionReason: string | null;
  siiClaimTrackingId: string | null;
  documentXml: string | null;
  countryMetadata: {
    emisor?: {
      rut: string;
      razonSocial: string;
      giro?: string;
      direccion?: string;
      comuna?: string;
    };
    receptor?: {
      rut: string;
      razonSocial: string;
    };
    totales?: {
      montoNeto: number;
      iva: number;
      montoTotal: number;
      montoExento?: number;
    };
    detalles?: Array<{
      nombre: string;
      cantidad: number;
      precioUnitario: number;
      montoItem: number;
    }>;
  };
  createdAt: string;
  updatedAt: string;
}

export interface ListReceivedDocumentsResponse {
  items: ReceivedDocumentListItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface AcceptDocumentResponse {
  success: boolean;
  documentId: string;
  acceptedAt: string;
  siiClaimTrackingId?: string;
}

export interface RejectDocumentResponse {
  success: boolean;
  documentId: string;
  rejectedAt: string;
  siiClaimTrackingId?: string;
}

export interface PendingCountResponse {
  count: number;
}

// Display helpers
export const DTE_TYPE_LABELS: Record<DteTypeCode, string> = {
  33: "Factura Electrónica",
  34: "Factura Exenta",
  52: "Guía de Despacho",
  56: "Nota de Débito",
  61: "Nota de Crédito",
};

export const ACCEPTANCE_STATUS_LABELS: Record<AcceptanceStatus, string> = {
  pending: "Pendiente",
  accepted: "Aceptado",
  rejected: "Rechazado",
};

export const ACCEPTANCE_STATUS_COLORS: Record<AcceptanceStatus, string> = {
  pending: "bg-yellow-100 text-yellow-800",
  accepted: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
};
